export default __webpack_public_path__ + "static/media/erubber.21a0bfed.png";